import React from 'react'
import { Switch, Route } from 'react-router-dom'

import RouteLoginForgotPasswordIndex from './forgot-password/index'
import RouteLoginForgotPasswordConfirmation from './forgot-password/confirmation'

const RouteLoginForgotPassword = ({ match: { path } }) => (
  <Switch>
    <Route path={path} exact component={RouteLoginForgotPasswordIndex} />
    <Route
      path={`${path}/confirmation`}
      component={RouteLoginForgotPasswordConfirmation}
    />
  </Switch>
)

export default RouteLoginForgotPassword



// WEBPACK FOOTER //
// ./src/routes/login/forgot-password.js